import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { IoArrowBack } from 'react-icons/io5'; // Importing Back Icon
import style from '../css/BookingDetails.module.css';

const BookingDetails = () => {
	const { order_number } = useParams();
	const navigate = useNavigate();
	const [bookingData, setBookingData] = useState(null);
	const [loading, setLoading] = useState(true);
	const [accepting, setAccepting] = useState(false);
	const [agentID, setAgentID] = useState(null);
	const [error, setError] = useState('');

	useEffect(() => {
		const storedUserID = localStorage.getItem('user_id');

		if (storedUserID) {
			setAgentID(storedUserID);
		} else {
			setError('User ID not found in storage');
		}
	}, []);

	const fetchBookingDetails = async () => {
		try {
			const response = await fetch(
				`https://hometech-repairs.in/homeTech/FetchBooking.php?order_number=${order_number}`
			);
			const result = await response.json();
			if (result.data) {
				setBookingData(result.data);
			} else {
				setBookingData(null);
			}
		} catch (error) {
			setError('Failed to fetch booking details');
			setBookingData(null);
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		if (order_number) {
			fetchBookingDetails();
			const interval = setInterval(fetchBookingDetails, 2000);
			return () => clearInterval(interval);
		}
	}, [order_number]);

	const acceptOrder = async () => {
		if (!bookingData || !agentID) {
			setError('Unable to accept order');
			return;
		}

		setAccepting(true);
		try {
			const response = await fetch(
				'https://hometech-repairs.in/homeTech/accept_order.php',
				{
					method: 'POST',
					headers: { 'Content-Type': 'application/json' },
					body: JSON.stringify({
						order_number: bookingData.order_number,
						agent_id: agentID,
					}),
				}
			);
			const result = await response.json();

			if (result.status) {
				setError('Order accepted successfully!');
				setBookingData({ ...bookingData, status: 'Accepted' });
			} else {
				setError(result.msg);
			}
		} catch (error) {
			setError('Failed to accept order');
		} finally {
			setAccepting(false);
		}
	};

	if (loading) {
		return (
			<div className={style.centered}>
				<div className={style.loader}></div>
			</div>
		);
	}

	if (!bookingData) {
		return (
			<div className={style.container}>
				<div className={style.navbar}>
					<IoArrowBack
						className={style.backIcon}
						onClick={() => navigate(-1)}
					/>
					<h2 className={style.navTitle}>Details</h2>
				</div>
				<p className={style.error}>No booking details found.</p>
				<button onClick={() => navigate(-1)} className={style.goBack}>
					Go Back
				</button>
			</div>
		);
	}

	return (
		<div className={style.container}>
			{/* Navbar with Back Icon and Title */}
			<div className={style.navbar}>
				<IoArrowBack className={style.backIcon} onClick={() => navigate(-1)} />
				<h2 className={style.navTitle}>Details</h2>
			</div>

			<p>{error}</p>
			<p className={style.date}>
				{bookingData.date
					? new Date(bookingData.date).toLocaleDateString('en-GB')
					: 'No date available'}
			</p>
			<h2 className={style.orderNumber}>Order #: {bookingData.order_number}</h2>

			<p
				className={`${style.status} ${
					bookingData.status === 'Completed' ? style.completed : style.pending
				}`}
			>
				{bookingData.status}
			</p>

			<div className={style.details}>
				<h3 className={style.sectionTitle}>Customer Details</h3>
				<p className={style.info}>{bookingData.name || 'N/A'}</p>
				<p className={style.info}>{bookingData.phone || 'N/A'}</p>
				<p className={style.info}>{bookingData.email || 'N/A'}</p>
				<p className={style.info}>{bookingData.service || 'N/A'}</p>
				<p className={style.info}>{bookingData.location || 'N/A'}</p>
				<p className={style.info}>{bookingData.message || 'N/A'}</p>
			</div>

			<button
				className={style.acceptButton}
				onClick={acceptOrder}
				disabled={accepting}
			>
				{accepting ? 'Accepting...' : 'Accept Order'}
			</button>
		</div>
	);
};

export default BookingDetails;
